<template>
  <section class="c-section">
    <div class="c-section__content">
      <slot></slot>
    </div>
  </section>
</template>
<script>
export default {};
</script>
<style lang="scss">
@import "../_variables.scss";
.c-section {
  $t: &;
  max-width: 1680px;
  padding: 0 1rem 0 1rem;
  margin: 0 auto;
  @media (max-width: 1430px) {
    max-width: 1260px;
  }
  &--full {
    #{$t}__content {
      min-height: 100vh;
    }
  }
  &__content {
    padding: 2rem 0 4rem 0;
    border-bottom: 1px solid $brightGray;
  }
  &--gray {
    background-color: $brightGray;
  }
}
</style>
